import { BoxGeometry, Mesh } from 'three';
import { v3dMesh } from '@/Interfaces/common';
import { IV3D } from '@/Interfaces/v3d';
import { iItemModel } from '@/Constants/modelMeta';

declare let v3d: IV3D;
export function createCube(metaItem: iItemModel) {
    const geometry = new BoxGeometry(metaItem.box?.width ?? 0.5,  metaItem.box?.height ?? 0.5, metaItem.box?.depth ?? 0.1);
    const material = new v3d.MeshStandardMaterial({ color: '#00ff00', transparent: true, opacity: 0.2 });
    const cube = new Mesh(geometry, material) as unknown as v3dMesh;
    cube.name = metaItem.name;
    return cube;
}
